import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import serverList from "../../components/serverList/serverOptions.vue";
import infoList from "@/mixins/infoList";
import { banRoleList, unbanRoleLogin } from "@/api/role";
import { getGameServerMap, getUserInfoMap } from "@/utils/dictionary";
import BanSomePerson from "./components/banSomePerson.vue";
import BanRoleLogin from "./components/banRoleLogin.vue";
export default {
  components: {
    serverList: serverList,
    BanSomePerson: BanSomePerson,
    BanRoleLogin: BanRoleLogin
  },
  name: "userBanned",
  mixins: [infoList],
  data: function data() {
    return {
      centerDialogVisible: false,
      banRoleDialog: false,
      listApi: banRoleList,
      serverId: "",
      searchInfo: {},
      serverList: {},
      userList: {},
      banForm: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getGameServerMap();
          case 2:
            _this.serverList = _context.sent;
            _context.next = 5;
            return getUserInfoMap();
          case 5:
            _this.userList = _context.sent;
            _this.getTableData();
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    //改变switch开关
    changeWords: function changeWords(row, e) {
      if (e == false) {
        row.type = "";
        row.Forbidden_words = "";
      }
    },
    backPerson: function backPerson(res) {
      this.centerDialogVisible = res.isback;
    },
    //直接调查询接口
    queryEvent: function queryEvent() {
      this.getTableData();
      if (this.tableData.length === 0) {
        this.$message({
          message: "暂无数据"
        });
      }
    },
    openBox: function openBox() {
      this.$notify({
        title: "聊天封禁（功能跟聊天禁言相似）【未对接接口】",
        message: "（1）确定研发玩家封禁调用接口地址，和校验方式。" + "(2) 可根据玩家平台账号，角色名+区服，角色Id，查询玩家封禁状态。" + "(3)可对查询结果的玩家进行封禁、解除封禁等操作" + "(4)封禁可选时长，1小时、3小时、24小时、永久，或者自定义时长",
        duration: 0
      });
    },
    unBanRole: function unBanRole(server_id, role_id) {
      var _this2 = this;
      var unbanRoleData = {
        server_id: server_id,
        role_list: [role_id]
      };
      unbanRoleLogin(unbanRoleData).then(function (res) {
        if (res.code == 0) {
          _this2.getTableData();
        }
      });
    },
    banRole: function banRole(server_id, role_id) {
      this.banForm.serverId = server_id;
      this.banForm.roleId = role_id;
      this.banRoleDialog = true;
    },
    banFinish: function banFinish() {
      this.banRoleDialog = false;
      this.getTableData();
    }
  }
};